import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { jwtDecode } from 'jwt-decode';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private isLoggedInSubject = new BehaviorSubject<boolean>(false);

  private tokenSubject = new BehaviorSubject<string | null>(this.getToken());
  token$ = this.tokenSubject.asObservable();  // Exponer el observable para que otros componentes se suscriban

  constructor(private router:Router) {}

  getDecodedToken(): any {
    const token = localStorage.getItem('jwtToken');
    if (token) {
      try {
        return jwtDecode(token); // Decodifica el token y devuelve el payload
      } catch (error) {
        console.error('Error decoding token:', error);
      }
    }
    return null;
  }

  setToken(token: string): void {
    localStorage.setItem('jwtToken', token); 
    this.tokenSubject.next(token);  
  }


  getToken(): string | null {
    return localStorage.getItem('jwtToken');
  }
  
  login(token:string) {
    localStorage.setItem('jwtToken', token);
    this.router.navigate(['/panel']);
    this.isLoggedInSubject.next(true); 
  }

  logout() {
    localStorage.removeItem('jwtToken');
    this.router.navigate(['/log-in']);
    this.isLoggedInSubject.next(false);
  }

  logoutWithoutNotification() {
    localStorage.removeItem('log-in');
    this.router.navigate(['/log-in']);
  }


  getRole(): string | null {
    const decodedToken = this.getDecodedToken();
    return decodedToken ? decodedToken.role : null; 
  }

  getUserName(): string | null {
    const decodedToken = this.getDecodedToken();
    return decodedToken ? decodedToken.Name : null; 
  }

  getUserSurname(): string | null {
    const decodedToken = this.getDecodedToken();
    return decodedToken ? decodedToken.Surname : null; 
  }

  getPhoto(): string | null {
    const decodedToken = this.getDecodedToken();
    return decodedToken ? decodedToken.Photo : null;
  }

  getUserEmail(): string | null {
    const decodedToken = this.getDecodedToken();
    return decodedToken ? decodedToken.Email : null; 
  }

  checkSession() {
    const token = localStorage.getItem('jwtToken');
    if (token) {
      this.isLoggedInSubject.next(true); 
    } else {
      this.isLoggedInSubject.next(false); 
    }
  }
}
